import {
    instance as axios,
    setJwtToken,
    setMultiPartHeader,
} from "../../config/axiosInstance";


// ------------------------Edit Plan------------------
export const updatePlanApi = async (data) => {
    const endPoint = `plan`;
    return await axios.post(endPoint, data, setJwtToken());
};

// ------------------------- event detail------------
export const planDetailApi = async () => {
    const endPoint = `plan`;
    return await axios.get(endPoint, setJwtToken());
};

